<div class="skeletor-clasif">
  <div class="skeletor-clasif-header">
    <p-skeleton width="16rem" />
    <p-skeleton width="12rem" />
  </div>

  <div class="skeletor-clasif-panel">
    <div class="skeletor-clasif-toolbar">
      <div class="skeletor-clasif-toolbar-left">
        <p-skeleton [width]="'12rem'" [height]="'1rem'" />
        <p-skeleton [width]="'10rem'" [height]="'1rem'" />
      </div>
      <p-skeleton [width]="'10rem'" [height]="'2.5rem'" />
    </div>

    <div class="skeletor-clasif-tree">
      <div *ngFor="let i of rows" class="skeletor-tree-row">
        <p-skeleton shape="circle" size="14px" class="mr-2" />
        <div class="skeletor-label">
          <p-skeleton [width]="'20rem'" [height]="'1rem'" />
        </div>
        <div class="skeletor-row-actions">
          <p-skeleton width="6rem" height="2rem" />
          <p-skeleton width="2rem" height="2rem" />
        </div>
      </div>
    </div>
  </div>
</div>

